import { useGetNflAllTimeGreatsLeadersQuery } from "../store/api/nflApi";

export const useNflAllTimeGreatsLeaderboard = ({
  stat,
  page = 0,
  pageSize = 25,
  leagueScope,
} = {}) => {
  const { data, isLoading, isFetching, error } =
    useGetNflAllTimeGreatsLeadersQuery({
      stat,
      page: page + 1,
      pageSize,
      leagueScope,
    });

  return {
    data,
    results: data?.results || [],
    totalResults: data?.totalResults || 0,
    isLoading: isLoading || isFetching,
    error,
  };
};
